export default function FormatUnderlineIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 18}
      height={height ? height : width ? width : 18}
      viewBox="0 96 960 960"
    >
      <path
        fill="currentColor"
        d="M230 949.915q-16.707 0-28.158-11.502t-11.451-28.283q0-16.781 11.451-28.39 11.451-11.609 28.158-11.609h500q16.707 0 28.158 11.784 11.451 11.785 11.451 28.566t-11.451 28.108Q746.707 949.915 730 949.915H230Zm250-153.001q-108.479 0-171.196-61.891-62.718-61.892-62.718-168.675V267.74q0-20.839 14.788-35.442 14.789-14.602 35.718-14.602 20.929 0 35.756 14.602 14.826 14.603 14.826 35.442v295.782q0 63 35.413 99.022Q418 698.565 480 698.565t97.413-36.021q35.413-36.022 35.413-99.022V267.74q0-20.839 15.071-35.442 15.071-14.602 36.001-14.602 20.929 0 35.755 14.602 14.826 14.603 14.826 35.442v298.608q0 106.783-63 168.675-63 61.891-171.479 61.891Z"
      />
    </svg>
  );
}
